// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RevokeOAuthApplicationMutationVariables = Types.Exact<{
  applicationId: Types.Scalars["ID"]["input"];
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type RevokeOAuthApplicationMutation = {
  __typename?: "Mutation";
  revokeOauthApplication: {
    __typename?: "RevokeOauthApplicationPayload";
    success: boolean;
  };
};

export const RevokeOAuthApplicationDocument = gql`
  mutation RevokeOAuthApplication($applicationId: ID!, $organizationSlug: ID!) {
    revokeOauthApplication(
      applicationId: $applicationId
      organizationSlug: $organizationSlug
    ) {
      success
    }
  }
`;
export type RevokeOAuthApplicationMutationFn = Apollo.MutationFunction<
  RevokeOAuthApplicationMutation,
  RevokeOAuthApplicationMutationVariables
>;

/**
 * __useRevokeOAuthApplicationMutation__
 *
 * To run a mutation, you first call `useRevokeOAuthApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeOAuthApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeOAuthApplicationMutation, { data, loading, error }] = useRevokeOAuthApplicationMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useRevokeOAuthApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeOAuthApplicationMutation,
    RevokeOAuthApplicationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevokeOAuthApplicationMutation,
    RevokeOAuthApplicationMutationVariables
  >(RevokeOAuthApplicationDocument, options);
}
export type RevokeOAuthApplicationMutationHookResult = ReturnType<
  typeof useRevokeOAuthApplicationMutation
>;
export type RevokeOAuthApplicationMutationResult =
  Apollo.MutationResult<RevokeOAuthApplicationMutation>;
export type RevokeOAuthApplicationMutationOptions = Apollo.BaseMutationOptions<
  RevokeOAuthApplicationMutation,
  RevokeOAuthApplicationMutationVariables
>;
